import Vue from 'vue'
import { mapState, mapActions } from 'vuex'

Vue.mixin({
	data() {
		return {
			page: 1,  // 当前页
			pageSizeArr: [10,20,30,50],  // 可切换的每页条数
			page_size: 10,  // 每页条数
			totalCount: 0,  // 总数据量
			
			isLoading: false,
			isReady: false
		}
	},
	computed: {
		...mapState(['userInfo', 'token', 'sysInfo', 'swiper'])
	},
	methods: {
		...mapActions(['getUser', 'setUserInfo', 'setToken', 'logout', 'setSysInfo', 'setSwiper'])
	}
})
